import { EvaluacionesEffects } from './evaluaciones.effects';

export const effectsArray: any[] = [ EvaluacionesEffects ];

export  * from './evaluaciones.effects';
